import { MainserviceService } from './../mainservice.service';
import { Component, OnInit } from '@angular/core';
import { SlicePipe } from "@angular/common";
declare interface TableData {
    headerRow: string[];
    dataRows: string[][];
}

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
    //search
    userFilter:any = { name: ''}
    //pagination
    p: number = 1; 
    //order
    order:any='created';
    reverse:boolean =true;
   

    users: any;
    constructor(private mainserv: MainserviceService) {

    }

    ngOnInit() {
        this.getusers()
    }
    getusers() {
        this.mainserv.getUsers().subscribe(data => {
            this.users = data
            console.log(this.users.created)      

        });
    }

    setOrder(nOrder:string){
        if(this.order === nOrder){
            this.reverse =!this.reverse;
        }
        this.order = nOrder;
    }


}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/users/users.component.ts